import React from 'react';
import { AdminHeader } from '../styles/style';
import ottLogo from '../images/on-the-table.svg';
import vfLogo from '../images/vancouver-foundation-white.png';
import { Link } from 'react-router-dom';

const Header = ({ currentUser }) => (
  <AdminHeader>
    <div>
      <a href={process.env.REACT_APP_BASE_URL}><img alt="On the Table" src={ottLogo}/></a>
      <a href="https://www.vancouverfoundation.ca"><img alt="An Invitation from Vancouver Foundation" src={vfLogo}/></a>
    </div>
    <p style={{color: 'white'}}>
      {currentUser && `${currentUser.firstname ? currentUser.firstname : ''} ${currentUser.lastname ? currentUser.lastname : ''}${currentUser.firstname || currentUser.lastname ? ' - ' : ''}`}
      <Link to="/host/signout">Sign Out</Link>
    </p>
  </AdminHeader>
);

export default Header
